import { AsyncPipe, CommonModule } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormControl, FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  MatAutocompleteModule,
  MatAutocompleteSelectedEvent,
} from "@angular/material/autocomplete";
import { MatError, MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import { SelectionInterface } from "../../../services/Interfaces";
import moment from "moment";

@Component({
  selector: "app-ng-autocomplete",
  templateUrl: "./ng-autocomplete.component.html",
  styleUrl: "./ng-autocomplete.component.scss",
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    ReactiveFormsModule,
    AsyncPipe,
    CommonModule,
    MatError,
    MatIconModule,
  ],
})
export class NgAutocompleteComponent implements OnInit {
  @Input() options: (string | number | object)[] = [];
  @Input() placeholder: string = "...";
  @Input() error: string = "...";
  @Input() control: FormControl = new FormControl();
  @Input() readonly: boolean = false;
  @Input() isDate: boolean = false;
  @Input() width: string = '';
  @Output() selected = new EventEmitter<string | SelectionInterface>();
  @Input() displayField: string = "";
  public isPanelOpen: boolean = false;
  private initialValue: any = null;
  private hasUserTyped = false;

  filteredOptions!: Observable<(string | number | object)[]>;

  constructor() { }

  ngOnInit() {
    if (this.control) {
      this.filteredOptions = this.control.valueChanges.pipe(
        startWith(""),
        map((value) => {
          // Detect typing: value changes from empty string to something
          if (value !== "" && value !== this.initialValue) {
            this.hasUserTyped = true;
          }
          return this._filter(value || "");
        })
      );
    }
  }

  private _filter(value: string): (string | object)[] {
    const filterValue = value;

    if (!Array.isArray(this.options) || this.options.length === 0) {
      return [];
    }

    if (this.isStringArray()) {
      return (this.options as string[]).filter(
        (option) =>
          option.toLowerCase().includes(filterValue) ||
          option.includes(filterValue)
      );
    } else {
      return (this.options as object[]).filter((option: any) => {
        const displayValue = option[this.displayField];
        return (
          displayValue?.toString().toLowerCase().includes(filterValue) ||
          displayValue?.toString().includes(filterValue)
        );
      });
    }
  }

  public isStringArray(): boolean {
    if (Array.isArray(this.options) && this.options.length > 0) {
      return typeof this.options[0] === "string";
    }
    return false;
  }
  public isObject(option: any): option is { [key: string]: any } {
    return typeof option === "object" && option !== null;
  }
  displayFn(option: any): string {
    if (!option) return "";

    if (this.isStringArray()) {
      return option;
    }

    if (this.isDate) {
      const rawValue = this.isObject(option)
        ? option[this.displayField]
        : option;
      // const formattedDate = moment(rawValue).format("MM/DD/YYYY");
      // return formattedDate === "Invalid date" ? "" : formattedDate;
      return rawValue;
    }

    if (this.isObject(option)) {
      return option[this.displayField];
    }

    return "";
  }
  openAutocomplete(input: HTMLInputElement): void {
    this.initialValue = this.control.value;
    this.hasUserTyped = false;

    this.control.setValue("");
    input.focus();
    input.dispatchEvent(new Event("input"));
  }
  onAutocompleteClosed(): void {
    if (!this.hasUserTyped && this.initialValue !== null) {
      this.control.setValue(this.initialValue);
    }
    this.initialValue = null;
  }
  onFocus() {
    this.control.setValue(this.control.value);
    // console.log(this.options);
  }
  onOptionSelected(event: MatAutocompleteSelectedEvent) {
    const selectedOption = event.option.value;
    this.selected.emit(selectedOption);
  }
}
